module.exports = __webpack_public_path__ + "img/montenegro.5238868f.png";